export function encodeNodeId(parts: string[]): string {
  return parts.map((p) => encodeURIComponent(p)).join("&");
}

export function decodeNodeId(nodeId: string): string[] {
  return nodeId.split("&").map((p) => decodeURIComponent(p));
}
